const drinks = [
  {
    name: 'Bottle of lager/beer/cider',
    icon: 'alcopop-bottle',
    volume: 330,
    units: 1.7,
    abv: 5,
    calories: 129
  },
  {
    name: 'Can of lager/beer/cider',
    icon: 'can-large',
    volume: 500,
    units: 2.7,
    abv: 5.5,
    calories: 270
  },
  {
    name: 'Pint of lower-strength lager/beer/cider',
    icon: 'beer',
    volume: 568,
    units: 2,
    abv: 3.6,
    calories: 170
  },
  {
    name: 'Pint of higher-strength lager/beer/cider',
    icon: 'beer',
    volume: 568,
    units: 3,
    abv: 5.2,
    calories: 222
  },
  {
    name: 'Small glass of wine',
    icon: 'wine-small',
    volume: 125,
    units: 1.5,
    abv: 12,
    calories: 113
  },
  {
    name: 'Standard glass of wine',
    icon: 'wine-med',
    volume: 175,
    units: 2.1,
    abv: 12,
    calories: 158
  },
  {
    name: 'Large glass of wine',
    icon: 'wine-large',
    volume: 250,
    units: 3,
    abv: 12,
    calories: 225
  },
  {
    name: 'Small measure of fortified wine',
    icon: 'fort-wine-small',
    volume: 50,
    units: 0.88,
    abv: 17.5,
    calories: 68
  },
  {
    name: 'Large measure of fortified wine',
    icon: 'fort-wine-large',
    volume: 75,
    units: 1.3,
    abv: 17.5,
    calories: 102
  },
  {
    name: 'Single shot of spirits',
    volume: 25,
    icon: 'shot',
    units: 1,
    abv: 40,
    calories: 50
  },
  {
    name: 'Standard shot of spirits',
    volume: 35,
    icon: 'shot',
    units: 1.4,
    abv: 40,
    calories: 70
  },
  {
    name: 'Double shot of spirits',
    volume: 50,
    icon: 'shot',
    units: 2,
    abv: 40,
    calories: 100
  },
  {
    name: 'Alcopop',
    icon: 'alcopop-bottle',
    volume: 275,
    units: 1.5,
    abv: 4.5,
    calories: 154
  }
];

export default drinks;
